import { Door, Location, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { Translation } from 'hooks/useTranslation/useTranslation';

export type Variant = 'icon' | 'switch';

export interface SecondLineText {
  id: string;
  text: string;
}

export interface DisabledRowsData {
  id: string;
  locationList: Location[];
}
export interface SecondRowsTextWarning {
  id: string;
  text: string;
}

type DataType = 'VisitorGroup' | 'LockGroup' | 'Door';

const hasLocksAssigned = (visitorGroup: VisitorGroup) => {
  const accessGrant = visitorGroup.accessGrants[0];
  return [...accessGrant.doors, ...accessGrant.locations.flatMap((location) => location.doors)].length > 0;
};

const isScheduleAssigned = (visitorGroup: VisitorGroup) => {
  const accessGrant = visitorGroup.accessGrants[0];
  return Boolean(accessGrant.accessSchedule.weekDays.length > 0);
};

const isUserGroupAssignedToDoor = (door: Location, visitorGroups: VisitorGroup[]) =>
  visitorGroups.filter((group) => {
    const accessGrant = group.accessGrants[0];
    return (
      accessGrant.doors.some((doorInAccessGrant) => doorInAccessGrant.id === door.id) ||
      accessGrant.locations.some((location) =>
        location.doors.some((doorInLocationInAccessGrant) => doorInLocationInAccessGrant.id === door.id)
      )
    );
  }).length > 0;

const isUserGroupAssignedToLocation = (lockGroup: Location, visitorGroups: VisitorGroup[]) =>
  visitorGroups.filter((group) =>
    group.accessGrants[0].locations.some((locationInAccessGrant) => locationInAccessGrant.id === lockGroup.id)
  ).length > 0;

export const getSecondLineTextWarning = (
  translation: Translation,
  type: DataType,
  item: VisitorGroup | Location | Door,
  visitorGroups?: VisitorGroup[]
): SecondRowsTextWarning | undefined => {
  const isAnyLocksAssigned = type === 'VisitorGroup' && hasLocksAssigned(item as VisitorGroup);
  const isAnyScheduleAssigned = type === 'VisitorGroup' && isScheduleAssigned(item as VisitorGroup);
  const isAnyUserGroupsAssignedToDoor =
    type === 'Door' && visitorGroups && isUserGroupAssignedToDoor(item as Location, visitorGroups);
  const isAnyUserGroupsAssignedToLock =
    type === 'LockGroup' && visitorGroups && isUserGroupAssignedToLocation(item as Location, visitorGroups);

  switch (type) {
    case 'Door':
      if (!isAnyUserGroupsAssignedToDoor) return { id: item.id, text: translation.no_user_groups_assigned_label };
      break;
    case 'LockGroup':
      if (!isAnyUserGroupsAssignedToLock) return { id: item.id, text: translation.no_user_groups_assigned_label };
      break;
    case 'VisitorGroup':
      if (!isAnyLocksAssigned && !isAnyScheduleAssigned)
        return { id: item.id, text: translation.no_lock_s__and_schedule_assigned };
      if (!isAnyLocksAssigned) return { id: item.id, text: translation.no_lock_s__assigned };
      if (!isAnyScheduleAssigned) return { id: item.id, text: translation.no_schedule_assigned };
      break;
    default:
      break;
  }

  return undefined;
};

export const ARROW_DOWN_WIDTH = 16;
export const ARROW_DOWN_HEIGHT = 16;
export const ARROW_RIGHT_WIDTH = 13;
export const ARROW_RIGHT_HEIGHT = 17;
